import RouteItem from ".";
import CardiovascularRespiratory from "../pages/department/CardiovascularRespiratory";
import CommunityPhysiotherapy from "../pages/department/CommunityPhysiotherapy";
import MusculoskeletalPhysiotherapy from "../pages/department/MusculoskeletalPhysiotherapy";
import NeuroPhysiotherapy from "../pages/department/NeuroPhysiotherapy";
//about SubMenu Pages

export const departmentRoutes: RouteItem = {
  key: "router-departments",
  title: "Departments",
  tooltip: "Departments",
  path: "/department",
  enabled: true,
  appendDivider: true,
  showInHeader: false,
  subRoutes: [
    {
      key: "router-department-musculoskeletal-physiotherapy",
      title: "Department Of Musculoskeletal",
      tooltip: "Department Of Musculoskeletal",
      path: "musculoskeletal-physiotherapy",
      enabled: true,
      component: MusculoskeletalPhysiotherapy,
      appendDivider: true,
    },
    {
      key: "router-department-neuro-physiotherapy",
      title: "Department Of Neuro",
      tooltip: "Department Of Neuro",
      path: "neuro-physiotherapy",
      enabled: true,
      component: NeuroPhysiotherapy,
      appendDivider: true,
    },
    {
      key: "router-department-cardiovascular-&-respiratory-physiotherapy",
      title: "Department Of Cardiovascular & Respiratory",
      tooltip: "Department Of Cardiovascular & Respiratory",
      path: "cardiovascular-&-respiratory-physiotherapy",
      enabled: true,
      component: CardiovascularRespiratory,
      appendDivider: true,
    },
    {
      key: "router-department-community-physiotherapy",
      title: "Department Of Community",
      tooltip: "Department Of Community",
      path: "community-physiotherapy",
      enabled: true,
      component: CommunityPhysiotherapy,
      appendDivider: true,
    },
  ],
};
